// extracted by mini-css-extract-plugin
module.exports = {"adminMainSection":"AdminMain_adminMainSection__3STSZ","dark":"AdminMain_dark__1V9wz"};